import './App.css';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Navbar from './components/Navbar';
import Projects from './components/Projects';
import Line from './components/Line';

function App() {
  return (
    <div className="App bg-color2">
      <Navbar/>
      <Hero/>
      <Line/>
      <About/>
      <Line/>
      <Projects/>
      <Line/>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default App;